Namespace 'CustomerVisualMode'

class CustomerVisualMode.UserWidgetDataTranslator
  name: (dataItem, {locale} = {}) ->
    userId = dataItem.name
    return @_nobodyTranslation(locale) if userId == 'nobody'
    return 'Robot' if userId == 'robot'
    dataItem.user_name

  _nobodyTranslation: (locale) ->
    I18n.t('customer.dashboard.conversations.details.assign.nobody', {locale})

